export default "__VITE_ASSET__BPwaqacd__"